import { useMutation } from "@tanstack/react-query";
import { addDeviceMutationFn } from "../../../../../api";
import { useEffect } from "react";
import { usePinFormState } from "./usePinFormState.ts";
import { EPinState } from "../../../../../store/pinFormStore.ts";
import { getPinRequestErrorMessage } from "../utils";
import { useAuthenticateDeviceMutationReaction } from "./useAuthenticateDeviceMutationReaction.ts";
import { usePersistStore } from "../../../../../store/persistStore.ts";

export function useAddDeviceMutationReaction() {
  const pinFormState = usePinFormState();
  const persistStore = usePersistStore();
  const authDevice = useAuthenticateDeviceMutationReaction();
  const addDevice = useMutation({
    mutationKey: ["addDevice"],
    mutationFn: addDeviceMutationFn,
  });

  useEffect(() => {
    switch (addDevice.status) {
      case "success": {
        authDevice.mutate({ pin: pinFormState.pin, fingerprint: persistStore.fingerprint });
        return;
      }
      case "error": {
        pinFormState.setState(EPinState.Initial);
        pinFormState.setError(getPinRequestErrorMessage(addDevice.error));
      }
    }
  }, [addDevice.status]);

  return addDevice;
}
